import { get } from "lodash";

import {
  FETCH_FREEZEEVENTS_REQUEST,
  FETCH_FREEZEEVENTS_SUCCESS,
  FETCH_FREEZEEVENTS_FAILURE
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case FETCH_FREEZEEVENTS_REQUEST:
      return {
        ...state,
        freezeEventsLoading: true
      };
    case FETCH_FREEZEEVENTS_SUCCESS: {
      const { factoringId, results, next, append } = action.payload;
      const existing = get(
        state,
        ["freezeEvents", factoringId, "results"],
        []
      );
      return {
        ...state,
        freezeEventsLoading: false,
        freezeEvents: {
          ...state.freezeEvents,
          [factoringId]: {
            results: append ? [...existing, ...results] : results,
            next
          }
        }
      };
    }
    case FETCH_FREEZEEVENTS_FAILURE:
      return {
        ...state,
        freezeEventsLoading: false
      };
    default:
      return state;
  }
};
